import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Gruppo di maschere 17029.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-20381b38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns is-centered" }
const _hoisted_2 = { class: "column is-half" }
const _hoisted_3 = { class: "left-aligned" }
const _hoisted_4 = { class: "mt-6 mb-6" }
const _hoisted_5 = { class: "meb-title" }
const _hoisted_6 = { class: "left-aligned" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "meb-text-p" }
const _hoisted_10 = { class: "meb-text-p" }
const _hoisted_11 = { class: "meb-text-p" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column is-half hidden-mobile pt-0" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-3 mb-3" }, null, -1))
const _hoisted_14 = { class: "left-aligned pb-6" }
const _hoisted_15 = { class: "carousel-container" }

import HomeSectionCarouselComponent from '@/components/HomeSectionCarouselComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeSection3Component',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('SEC_3_TITLE')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("ol", null, [
            _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.$t('SEC_3_STEP_1')), 1),
            _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.$t('SEC_3_STEP_2')), 1),
            _createElementVNode("li", _hoisted_11, _toDisplayString(_ctx.$t('SEC_3_STEP_3')), 1)
          ])
        ])
      ]),
      _hoisted_12
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(HomeSectionCarouselComponent, {
          image: "",
          name: "SEC_3_1"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel-bk/Raggruppa 17998.png",
          name: "SEC_3_2"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel-bk/Raggruppa 17999.png",
          name: "SEC_3_3"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel-bk/Raggruppa 18000.png",
          name: "SEC_3_4"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel-bk/Raggruppa 18001.png",
          name: "SEC_3_5"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel-bk/Raggruppa 18002.png",
          name: "SEC_3_6"
        })
      ])
    ])
  ], 64))
}
}

})